import axios from 'axios';

interface PublicInvoiceResponse {
  success: boolean;
  message?: string;
  data?: any;
}

const getInvoiceByIdAndPassword = async (
  id: string,
  cnpjDigits: string
): Promise<PublicInvoiceResponse> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_REST_API}invoices/passwordProtected/${id}`,
      { password: cnpjDigits },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return {
      success: true,
      message: response.data.message,
      data: response.data,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao validar CNPJ',
      };
    }
    return {
      success: false,
      message: 'Erro desconhecido ao validar CNPJ',
    };
  }
};

export default getInvoiceByIdAndPassword;
